import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFB3C7",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h40A3.5 3.5 0 0 1 47.5 4v24a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 28z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#EBEBEB",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h40A3.5 3.5 0 0 1 47.5 4v24a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 28z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0A0B09",
  "fill-rule": "evenodd",
  d: "M42.13 17.787c-.55 0-.997.45-.997 1.006s.447 1.007.997 1.007c.552 0 .998-.45.998-1.007 0-.556-.446-1.006-.998-1.006m-3.282-.779c0-.761-.645-1.378-1.44-1.378-.796 0-1.441.617-1.441 1.378 0 .761.645 1.379 1.44 1.379.796 0 1.44-.618 1.44-1.379Zm.005-2.679h1.59v5.358h-1.59v-.343c-.449.31-.991.491-1.576.491-1.547 0-2.801-1.266-2.801-2.827s1.254-2.827 2.801-2.827c.585 0 1.127.182 1.576.49zm-12.722.698v-.698h-1.627v5.358h1.631v-2.502c0-.843.906-1.297 1.535-1.297h.02V14.33c-.646 0-1.24.278-1.559.697m-4.054 1.981c0-.761-.645-1.378-1.44-1.378-.796 0-1.44.617-1.44 1.378 0 .761.644 1.379 1.44 1.379.795 0 1.44-.618 1.44-1.379m.005-2.679h1.59v5.358h-1.59v-.343a2.76 2.76 0 0 1-1.576.491c-1.547 0-2.801-1.265-2.801-2.827 0-1.561 1.254-2.827 2.802-2.827.584 0 1.126.182 1.575.49zm9.569-.144c-.635 0-1.236.199-1.638.748v-.604H28.43v5.358h1.602V16.87c0-.814.542-1.213 1.194-1.213.698 0 1.1.42 1.1 1.202v2.827h1.588V16.28c0-1.247-.983-2.095-2.263-2.095m-16.262 5.502h1.664v-7.745H15.39v7.745Zm-7.309.002h1.762V11.94H8.08zm6.162-7.749a6.192 6.192 0 0 1-1.802 4.398l2.436 3.351H12.7l-2.647-3.642.683-.516a4.463 4.463 0 0 0 1.782-3.59z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }